<template>
  <div class="container">
    <div class="wrapper">
      <slot></slot>
    </div>
    <span class="footer md-typescale-body-large">
      {{ t('main.copyright', { year: new Date().getFullYear() }) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
<style scoped>
.container {
  background-color: var(--md-sys-color-surface);
  min-height: 100vh;
  min-width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 72px;
  flex-direction: column;
}

.wrapper {
  width: 410px;
  margin: 0 auto;
  padding: var(--md-spacing-24) var(--md-spacing-16);
}

@media (min-width: 769px) {
  .container:has(.layout-container) .wrapper {
    width: 100%;
    max-width: 800px;
  }
}

.footer {
  padding: var(--md-spacing-8) var(--md-spacing-16);
  display: flex;
  color: var(--md-sys-color-on-surface);
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
